import axios from 'axios';
import { store } from '@/lib/store';
import { resetAuth } from '@/lib/authSlice';

const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const state = store.getState();
        const token = state.auth.token;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const { status } = error.response;

            if (status === 401) {
                // Unauthorized - Trigger Logout
                store.dispatch(resetAuth());
                // Allow AuthGuard to handle the redirect reactively based on state change
            } else if (status === 403) {
                console.error('Forbidden access');
            } else if (status >= 500) {
                console.error('Server error');
            }
        } else if (error.request) {
            console.error('Network error');
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
